import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-aligned",
  "use": "icon-aligned-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-aligned\"><path d=\"M291.9 453.5h341.6c8.1 0 14.7-7.2 14.7-16v-160c0-8.9-6.6-16-14.7-16H291.9c-8.1 0-14.7 7.2-14.7 16v160c-.1 8.8 6.5 16 14.7 16zm49.3-128h243v64h-243v-64zm505.7 239h-553c-9.2 0-16.7 7.2-16.7 16v160c0 8.9 7.5 16 16.7 16h553c9.2 0 16.7-7.2 16.7-16v-160c0-8.8-7.5-16-16.7-16zm-47.3 128H341.2v-64h458.5v64zM157.1 159.9h64v707.2h-64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol